var map = {
	"./img/NTFusion_logo.png": "ww4H",
	"./img/activity4/bg.jpg": "r9lL",
	"./img/activity4/dialog2.png": "zEj6",
	"./img/activity4/title.png": "52bR",
	"./img/common/fb.png": "RmCk",
	"./img/common/logo.png": "ZqiW",
	"./img/feature/title.png": "zUvI",
	"./img/feature6/title.png": "vZcr",
	"./img/header/home.png": "9EcW",
	"./img/home/pc/common.png": "GMCm",
	"./img/home/pc/index1.png": "gikw",
	"./img/home/pc/index1/describe.png": "IvZR",
	"./img/home/pc/index1/logo.png": "eY9f",
	"./img/home/pc/index1/slogan.png": "dqje",
	"./img/home/pc/news2.png": "NwJF",
	"./img/home/pc/role3/control/mo_btn1.png": "wQT4",
	"./img/home/pc/role3/control/mo_btn2.png": "4BY3",
	"./img/home/pc/role3/control/sg_btn1.png": "Iw0F",
	"./img/home/pc/role3/control/sg_btn2.png": "m9b3",
	"./img/home/pc/role3/control/xl_btn1.png": "JAua",
	"./img/home/pc/role3/control/xl_btn2.png": "p+kc",
	"./img/home/pc/role3/control/yg_btn1.png": "Mwb3",
	"./img/home/pc/role3/control/yg_btn2.png": "cOoM",
	"./img/home/pc/role3/control/ys_btn1.png": "at8Q",
	"./img/home/pc/role3/control/ys_btn2.png": "DK+g",
	"./img/home/pc/role3/control/zl_btn1.png": "L18l",
	"./img/home/pc/role3/control/zl_btn2.png": "+yUa",
	"./img/index/award1.png": "Imvf",
	"./img/index/award1_a.png": "8Rb3",
	"./img/index/award2.png": "iTGd",
	"./img/index/award2_a.png": "W4/w",
	"./img/index/award3.png": "3wKo",
	"./img/index/award3_a.png": "fvEI",
	"./img/index/award4.png": "JMEP",
	"./img/index/award4_a.png": "ALiw",
	"./img/index/award5.png": "Vnea",
	"./img/index/award5_a.png": "S3Vm",
	"./img/index/home.png": "zHJ2",
	"./img/index/kv.jpg": "SeFX",
	"./img/media5/role.png": "W+N/",
	"./img/media5/sence2.png": "POYM",
	"./img/media5/title.png": "Jvj3",
	"./img/news2/move1.png": "LsNE",
	"./img/news2/title.png": "K5/q",
	"./img/role3/bn/irole.png": "cYPT",
	"./img/role3/bn/name.png": "9Mta",
	"./img/role3/bn/role.png": "3gJ/",
	"./img/role3/bz/irole.png": "UUil",
	"./img/role3/bz/name.png": "WErk",
	"./img/role3/bz/role.png": "v+mm",
	"./img/role3/ch/irole.png": "ouKw",
	"./img/role3/ch/name.png": "kV9e",
	"./img/role3/ch/role.png": "SL2O",
	"./img/role3/cz/irole.png": "6ZOe",
	"./img/role3/cz/name.png": "sxDk",
	"./img/role3/cz/role.png": "NFks",
	"./img/role3/jw/irole.png": "0m4B",
	"./img/role3/jw/name.png": "2BWT",
	"./img/role3/jw/role.png": "G39J",
	"./img/role3/kc/irole.png": "D/H5",
	"./img/role3/kc/name.png": "NR0L",
	"./img/role3/kc/role.png": "gk5y",
	"./img/role3/kr/irole.png": "ssWb",
	"./img/role3/kr/name.png": "O0pq",
	"./img/role3/kr/role.png": "k6oV",
	"./img/role3/lxx/irole.png": "ygcs",
	"./img/role3/lxx/name.png": "V5Sx",
	"./img/role3/lxx/role.png": "jULg",
	"./img/role3/mx/irole.png": "e0AT",
	"./img/role3/mx/name.png": "UOz0",
	"./img/role3/mx/role.png": "nC/Y",
	"./img/role3/mz/irole.png": "jjjX",
	"./img/role3/mz/name.png": "6Rsn",
	"./img/role3/mz/role.png": "9qGh",
	"./img/role3/oo/irole.png": "A4zw",
	"./img/role3/oo/name.png": "nkG8",
	"./img/role3/oo/role.png": "neAQ",
	"./img/role3/qa/irole.png": "h+AB",
	"./img/role3/qa/name.png": "VqF9",
	"./img/role3/qa/role.png": "a95t",
	"./img/role3/swbnzk/irole.png": "LW/W",
	"./img/role3/swbnzk/name.png": "JFyA",
	"./img/role3/swbnzk/role.png": "B8k9",
	"./img/role3/sy/irole.png": "FJP+",
	"./img/role3/sy/name.png": "hFqV",
	"./img/role3/sy/role.png": "8JK2",
	"./img/role3/title.png": "htzI",
	"./img/role3/tsz/irole.png": "iiPb",
	"./img/role3/tsz/name.png": "UdOZ",
	"./img/role3/tsz/role.png": "E5Qy",
	"./img/role3/tysdags/irole.png": "MjTx",
	"./img/role3/tysdags/name.png": "gkEq",
	"./img/role3/tysdags/role.png": "n5Y6",
	"./img/role3/u/irole.png": "V/ne",
	"./img/role3/u/name.png": "Z6pZ",
	"./img/role3/u/role.png": "fJtn",
	"./img/role3/wxsjglm/irole.png": "7DyG",
	"./img/role3/wxsjglm/name.png": "m9hj",
	"./img/role3/wxsjglm/role.png": "7YBL",
	"./img/role3/xk/irole.png": "HGLi",
	"./img/role3/xk/name.png": "Ouzl",
	"./img/role3/xk/role.png": "omZw",
	"./img/role3/yjyx/irole.png": "acG2",
	"./img/role3/yjyx/name.png": "Q07H",
	"./img/role3/yjyx/role.png": "X20v",
	"./img/role3/yzzzbq/irole.png": "p/Jk",
	"./img/role3/yzzzbq/name.png": "Si70",
	"./img/role3/yzzzbq/role.png": "pM3O",
	"./img/role3/zxrx/irole.png": "gXZt",
	"./img/role3/zxrx/name.png": "N2Hl",
	"./img/role3/zxrx/role.png": "kub4",
	"./img/sprite2310.png": "2+89",
	"./mobile_img/common.png": "722s",
	"./mobile_img/common/dialog1.png": "b6r5",
	"./mobile_img/community/fb.png": "975i",
	"./mobile_img/feature/title.png": "732p",
	"./mobile_img/feature6/title.png": "6ssp",
	"./mobile_img/index/award1.png": "L5ry",
	"./mobile_img/index/award1_active.png": "rN3Y",
	"./mobile_img/index/award2.png": "zpaB",
	"./mobile_img/index/award2_active.png": "KoqK",
	"./mobile_img/index/award3.png": "HwOz",
	"./mobile_img/index/award3_active.png": "JA1P",
	"./mobile_img/index/award4.png": "4HK3",
	"./mobile_img/index/award4_active.png": "/uiG",
	"./mobile_img/index/award5.png": "J87g",
	"./mobile_img/index/award5_active.png": "bF1I",
	"./mobile_img/index/kv.jpg": "7csd",
	"./mobile_img/index1.png": "w/sf",
	"./mobile_img/index1/slogan.png": "e5zT",
	"./mobile_img/media5/title.png": "osks",
	"./mobile_img/news2.png": "rXBt",
	"./mobile_img/news2/title.png": "XgvL",
	"./mobile_img/role3/bn/irole.png": "J/FR",
	"./mobile_img/role3/bn/m_name.png": "64jf",
	"./mobile_img/role3/bn/m_role.png": "6Put",
	"./mobile_img/role3/bz/irole.png": "7MP/",
	"./mobile_img/role3/bz/m_name.png": "TeuV",
	"./mobile_img/role3/bz/m_role.png": "WdPm",
	"./mobile_img/role3/ch/irole.png": "AZdE",
	"./mobile_img/role3/ch/m_name.png": "lXkl",
	"./mobile_img/role3/ch/m_role.png": "8mrw",
	"./mobile_img/role3/control2/mo1.png": "P93I",
	"./mobile_img/role3/control2/mo2.png": "PTs6",
	"./mobile_img/role3/control2/sg1.png": "mqK3",
	"./mobile_img/role3/control2/sg2.png": "/zjm",
	"./mobile_img/role3/control2/xl1.png": "m+XX",
	"./mobile_img/role3/control2/xl2.png": "DmIf",
	"./mobile_img/role3/control2/yg1.png": "eFAD",
	"./mobile_img/role3/control2/yg2.png": "mQNU",
	"./mobile_img/role3/control2/ys1.png": "VacX",
	"./mobile_img/role3/control2/ys2.png": "Mn/+",
	"./mobile_img/role3/control2/zl1.png": "y2gU",
	"./mobile_img/role3/control2/zl2.png": "qf4V",
	"./mobile_img/role3/cz/irole.png": "YFk4",
	"./mobile_img/role3/cz/m_name.png": "DuFM",
	"./mobile_img/role3/cz/m_role.png": "DUL1",
	"./mobile_img/role3/jw/irole.png": "XfKh",
	"./mobile_img/role3/jw/m_name.png": "FVU1",
	"./mobile_img/role3/jw/m_role.png": "yIHb",
	"./mobile_img/role3/kc/irole.png": "xHe3",
	"./mobile_img/role3/kc/m_name.png": "J421",
	"./mobile_img/role3/kc/m_role.png": "TZ41",
	"./mobile_img/role3/kr/irole.png": "6ZSD",
	"./mobile_img/role3/kr/m_name.png": "KsOX",
	"./mobile_img/role3/kr/m_role.png": "vxjn",
	"./mobile_img/role3/lxx/irole.png": "zILe",
	"./mobile_img/role3/lxx/m_name.png": "cmRy",
	"./mobile_img/role3/lxx/m_role.png": "ZLpv",
	"./mobile_img/role3/mx/irole.png": "qrlN",
	"./mobile_img/role3/mx/m_name.png": "P+Ol",
	"./mobile_img/role3/mx/m_role.png": "vVVc",
	"./mobile_img/role3/mz/irole.png": "GVIk",
	"./mobile_img/role3/mz/m_name.png": "K9Hi",
	"./mobile_img/role3/mz/m_role.png": "0qeY",
	"./mobile_img/role3/oo/irole.png": "Res3",
	"./mobile_img/role3/oo/m_name.png": "J6Cv",
	"./mobile_img/role3/oo/m_role.png": "TKFx",
	"./mobile_img/role3/qa/irole.png": "ZVxF",
	"./mobile_img/role3/qa/m_name.png": "9c4Z",
	"./mobile_img/role3/qa/m_role.png": "324U",
	"./mobile_img/role3/swbnzk/irole.png": "RGQt",
	"./mobile_img/role3/swbnzk/m_name.png": "lBtt",
	"./mobile_img/role3/swbnzk/m_role.png": "qjwy",
	"./mobile_img/role3/sy/irole.png": "gpZr",
	"./mobile_img/role3/sy/m_name.png": "k+ZC",
	"./mobile_img/role3/sy/m_role.png": "zO85",
	"./mobile_img/role3/title.png": "LYEO",
	"./mobile_img/role3/tsz/irole.png": "I17t",
	"./mobile_img/role3/tsz/m_name.png": "vcVp",
	"./mobile_img/role3/tsz/m_role.png": "e386",
	"./mobile_img/role3/tysdags/irole.png": "voL4",
	"./mobile_img/role3/tysdags/m_name.png": "adpl",
	"./mobile_img/role3/tysdags/m_role.png": "4zuU",
	"./mobile_img/role3/u/irole.png": "NetW",
	"./mobile_img/role3/u/m_name.png": "UPY+",
	"./mobile_img/role3/u/m_role.png": "BS1r",
	"./mobile_img/role3/wxsjglm/irole.png": "/Y6U",
	"./mobile_img/role3/wxsjglm/m_name.png": "zRMn",
	"./mobile_img/role3/wxsjglm/m_role.png": "0/q/",
	"./mobile_img/role3/xk/irole.png": "6gl2",
	"./mobile_img/role3/xk/m_name.png": "4Ls1",
	"./mobile_img/role3/xk/m_role.png": "J/w7",
	"./mobile_img/role3/yjyx/irole.png": "Wos5",
	"./mobile_img/role3/yjyx/m_name.png": "DqWt",
	"./mobile_img/role3/yjyx/m_role.png": "Ioys",
	"./mobile_img/role3/yzzzbq/irole.png": "q49d",
	"./mobile_img/role3/yzzzbq/m_name.png": "FTlV",
	"./mobile_img/role3/yzzzbq/m_role.png": "+Oih",
	"./mobile_img/role3/zxrx/irole.png": "wORZ",
	"./mobile_img/role3/zxrx/m_name.png": "1UIk",
	"./mobile_img/role3/zxrx/m_role.png": "Qs2J",
	"./mobile_img/sprite2310.png": "KAp+",
	"./upload/commonality/20231121/170053375636586479149357.png": "m7lt",
	"./upload/commonality/20251009/0.jpg": "jhNa",
	"./upload/commonality/20251009/1.jpg": "Pms1",
	"./upload/commonality/20251009/2.jpg": "nkRG",
	"./upload/commonality/20251009/3.jpg": "UdrY",
	"./upload/commonality/20251009/4.jpg": "5M64",
	"./upload/commonality/20251009/5.jpg": "t12j",
	"./upload/picture/2.2.jpg": "tcEo",
	"./upload/picture/2.3.jpg": "d5/4",
	"./upload/picture/2.4.jpg": "iAHr",
	"./upload/picture/2.5.jpg": "YcAD",
	"./upload/picture/2.6.jpg": "Rq6h",
	"./upload/picture/2.7.jpg": "WiOl"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "JoGt";


//////////////////
// WEBPACK FOOTER
// ./static/hk ^\.\/.*$
// module id = JoGt
// module chunks = 7